import { useQuery } from 'react-query';
import { getClients } from '../../services/clients';

function useGetClients({ data = {}, loadingStatusOff = false, axiosConfig = {}, useQueryOptions = {} }) {
  return useQuery(
    ['clients', data],
    async () => {
      return getClients({
        data,
        loadingStatusOff,
        axiosConfig,
      });
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
      ...useQueryOptions,
    },
  );
}

export default useGetClients;
